import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { AnimateOnScrollModule } from 'primeng/animateonscroll';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DataViewModule } from 'primeng/dataview';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { KnobModule } from 'primeng/knob';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MeterGroupModule } from 'primeng/metergroup';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { PasswordModule } from 'primeng/password';
import { PopoverModule } from 'primeng/popover';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollerModule } from 'primeng/scroller';
import { SelectModule } from 'primeng/select';
import { SkeletonModule } from 'primeng/skeleton';
import { SliderModule } from 'primeng/slider';
import { SpeedDialModule } from 'primeng/speeddial';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';

// Centralize shared UI modules used by standalone components.
export const SHARED_UI_IMPORTS = [
  AccordionModule,
  AnimateOnScrollModule,
  AutoCompleteModule,
  BadgeModule,
  BreadcrumbModule,
  ButtonModule,
  CardModule,
  ChartModule,
  CheckboxModule,
  ChipModule,
  ConfirmDialogModule,
  DataViewModule,
  DatePickerModule,
  DialogModule,
  DrawerModule,
  DynamicDialogModule,
  FieldsetModule,
  FileUploadModule,
  InputMaskModule,
  InputNumberModule,
  InputTextModule,
  KnobModule,
  MegaMenuModule,
  MenuModule,
  MessageModule,
  MeterGroupModule,
  MultiSelectModule,
  PaginatorModule,
  PasswordModule,
  PopoverModule,
  ProgressBarModule,
  ProgressSpinnerModule,
  RadioButtonModule,
  ScrollerModule,
  SelectModule,
  SkeletonModule,
  SliderModule,
  SpeedDialModule,
  SplitButtonModule,
  StepsModule,
  TableModule,
  TabsModule,
  TagModule,
  TextareaModule,
  TimelineModule,
  ToastModule,
  ToggleSwitchModule,
  ToolbarModule,
  TooltipModule,
  TreeModule,
  TreeTableModule,
] as const;

// Optional app-level provider bridge when modules expose providers.
export function provideSharedUi(): EnvironmentProviders {
  return importProvidersFrom(...SHARED_UI_IMPORTS);
}
